import * as React from 'react';
export const IcMason = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.27 2.73a2.52 2.52 0 00-3.54 0l-1.5 1.5a2.51 2.51 0 00-.56 2.68l-1.38 1.38a1 1 0 00-.24 1l.81 2.41-1.65 1.65-1.8-1.79a2 2 0 00-2.82 0l-1 1A2 2 0 005 13.67l-1 6A2 2 0 006 22c.11.01.22.01.33 0l6-1a2 2 0 001.08-.56l1-1a2 2 0 000-2.82l-1.79-1.8 2.09-2.08a1 1 0 00.24-1l-.81-2.41.95-.94c.294.09.603.128.91.11a2.49 2.49 0 001.77-.73l1.5-1.5a2.52 2.52 0 000-3.54z'
      fill='currentColor'
    />
  </svg>
);
